const IMAGE_MIME_BY_EXTENSION = Object.freeze({
  avif: 'image/avif',
  gif: 'image/gif',
  heic: 'image/heic',
  heif: 'image/heif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
});

const VIDEO_MIME_BY_EXTENSION = Object.freeze({
  '3gp': 'video/3gpp',
  avi: 'video/x-msvideo',
  m4v: 'video/x-m4v',
  mov: 'video/quicktime',
  mp4: 'video/mp4',
  webm: 'video/webm',
});
export const DOCUMENT_MIME_BY_EXTENSION = Object.freeze({
  pdf: 'application/pdf', txt: 'text/plain', csv: 'text/csv', doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel', xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint', pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  odt: 'application/vnd.oasis.opendocument.text', ods: 'application/vnd.oasis.opendocument.spreadsheet',
  odp: 'application/vnd.oasis.opendocument.presentation', rtf: 'application/rtf', zip: 'application/zip',
});

function extensionOf(file) {
  const name = String(file?.name || '').toLowerCase();
  const match = name.match(/\.([a-z0-9]+)$/);
  return match?.[1] || '';
}

export function mediaKindForFile(file) {
  const declaredType = String(file?.type || '').toLowerCase();
  if (declaredType.startsWith('image/')) return 'imagem';
  if (declaredType.startsWith('video/')) return 'video';
  if (declaredType.startsWith('audio/')) return 'audio';
  const extension = extensionOf(file);
  if (IMAGE_MIME_BY_EXTENSION[extension]) return 'imagem';
  if (VIDEO_MIME_BY_EXTENSION[extension]) return 'video';
  return null;
}

export function documentMimeType(file) {
  const extension = extensionOf(file);
  const expected = DOCUMENT_MIME_BY_EXTENSION[extension];
  if (!expected) return null;
  const declared = String(file?.type || '').toLowerCase().split(';')[0];
  // Browsers frequently leave this blank; never accept an explicitly unrelated MIME.
  return !declared || declared === expected || (extension === 'csv' && declared === 'application/csv')
    || (extension === 'rtf' && declared === 'text/rtf') || (extension === 'zip' && declared === 'application/x-zip-compressed')
    ? expected : null;
}

export function documentExtension(file) {
  return documentMimeType(file) ? extensionOf(file) : null;
}

export function uploadMimeType(file, kind) {
  const declaredType = String(file?.type || '').toLowerCase();
  if (kind === 'imagem' && declaredType.startsWith('image/')) return declaredType;
  if (kind === 'video' && declaredType.startsWith('video/')) return declaredType;
  if (kind === 'audio' && declaredType.startsWith('audio/')) return declaredType;
  const extension = extensionOf(file);
  if (kind === 'documento') return documentMimeType(file);
  if (kind === 'imagem' && IMAGE_MIME_BY_EXTENSION[extension]) return IMAGE_MIME_BY_EXTENSION[extension];
  if (kind === 'video' && VIDEO_MIME_BY_EXTENSION[extension]) return VIDEO_MIME_BY_EXTENSION[extension];
  return kind === 'imagem' ? 'image/jpeg' : kind === 'video' ? 'video/mp4' : 'audio/webm';
}